











































import {
  LayoutConfig,
  LayoutDataSet,
} from '@/uikit/components/AppDefaultLayout/types/LayoutTypes';

import AppPicture from '@/uikit/components/AppPicture/AppPicture.vue';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';
import background from './background.svg';
import ContentSlider from '@/uikit/components/AppDefaultLayout/components/sections/signboardNew/ContentSlider.vue';

export default {
  /// добавлять данные или параметры, в
  /// exampleCfgSet
  /// больше тут никаких пропсов не будет
  props: {
    cfg: {
      type: Object as () => LayoutConfig['content']['startPage']['sections']['signboard'],
      required: true,
    },
    data: {
      type: Object as () => LayoutDataSet['signboard'],
    },
  },
  components: { ContentSlider, AppButtonNew, AppPicture },
  data() {
    return {
      background,
    };
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/components/sections/signboardNew/SignboardNew.vue